module.exports = __webpack_public_path__ + "media/images/avatar-5196682c.png";